import {
  Dialog as DialogCore,
  DialogTitle as DialogTitleCore,
  DialogContent as DialogContentCore,
  IconButton as IconButtonCore,
} from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Dialog = lib.styled(DialogCore)`
  width: 400px !important;
  margin: auto;

  .MuiDialog-paper {
    margin: 10px;
    height: 600px !important;
    min-width: 360px;
  }

  .rst__tree {
    zoom: 97%;
  }
`;

export const DialogTitle = lib.styled(DialogTitleCore)`
  position: relative;
  text-align: center;
  padding: 10px 24px !important;
  margin-top: 10px !important;
  font-size: 17px;
  font-weight: 600;
  font-family: Nunito !important;

  .title {
    display: block;
}
`;

export const IconButton = lib.styled(IconButtonCore)`
  position: absolute !important;
  right: 12px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
`;

export const DialogContent = lib.styled(DialogContentCore)`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;

  padding: 5px !important;
  overflow: scroll;
  padding-right: 24px !important;
  padding-left: 24px !important;

  .whatsapp-preview-container {
    display: flex;
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
  }

  .parameters-container {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
  }

  .MuiButton-containedPrimary {
    background-color: ${colors.green08} !important;
    margin-bottom: 20px !important;

    &:hover {
      background-color: ${colors.green08} !important;
    }
  }
`;
